// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__3fUwo","rounded":"Icon_rounded__PXptl","outlined":"Icon_outlined__17gIb"};